module.exports = __webpack_public_path__ + "img/robot.4e1c57f3.png";